export const userRegistrationComplete = {
    title: 'ユーザ登録',
    heading: 'ユーザ登録が完了しました',
    description: '招待メールを送信しましたので、ご確認の上ログインお願いいたします。',
    backToLogin: 'ログインページに戻る'
}
